import { Box, Container, Typography, Button } from '@mui/material'
import React from 'react'

import FullHeight from 'react-full-height'
import { Link } from 'react-router-dom'
import "@fontsource/questrial"
import "@fontsource/archivo"
import "@fontsource/mukta"
const Section3 = () => {
  return (
    <div>
        
          <Box sx={{mx:2,p:4,mb:5,mt:20,background:"white",textAlign:"center",border:1,borderRadius:2,borderColor:"black"}}>
            <Box id="howwecreate">
              <Typography variant="h4" style={{fontFamily:"Archivo",textDecoration:"underline"}}>What technologies do we use</Typography>
              <Box sx={{textAlign:"left",mx:5,mt:3}}>
                <Typography variant="h6" style={{fontFamily:"Questrial",fontWeight:"600"}}>Frontend</Typography>
                <Typography variant="p" style={{fontFamily:"Mukta"}}>We use react which is a well-known Javascript framework that is being used by many big websites like Instagram, Netflix and Facebook just to name a few. We also incorporate Material UI which is a CSS framework built by google to make our design more uniform a clean. To complement the Material UI, we add in a bit of bootstrap to make it look that much better.</Typography>
                <br/><br/>
                <Typography variant="h6" style={{fontFamily:"Questrial",fontWeight:"600"}}>Backend</Typography>
                <Typography variant="p" style={{fontFamily:"Mukta"}}>As for the backend, our motto is simple but effective, instead of mixing in multiple technologies, we resort to using only one technology to make it easy to debug and scale. We make use of firebase, which is managed by Google. It is robust and offers a wide buffet of features to ensure that you build a top-notch website.</Typography>
              </Box>
            </Box>
            <br/>
           <Link to="/Samples" style={{textDecoration:"none",color:'inherit'}}> <Button variant="contained" sx={{mt:2}} style={{background:"black"}}><a style={{textDecoration:"none",color:"inherit"}}  href="#howwecreate">Our Samples</a></Button></Link>
          </Box>
    </div>
  )
}

export default Section3